export default __webpack_public_path__ + "static/media/blog1.3d78ec7c.png";